import { n as i } from "./Logger-CmiOOsKC.js";
import { a as o } from "./tracebehavior-5_qSKjs6.js";
var t = /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/;
function e(r) {
  return typeof r == "string" && r !== "" && !o(r);
}
function a(r, n) {
  return e(r) ? t.test(r) ? r : (i.warn(`[${n}] Ignoring invalid color "${r}" — expected #RRGGBB or #RRGGBBAA hex`), null) : null;
}
export {
  e as n,
  a as r,
  t
};

//# sourceMappingURL=bindingValues-BuN2Qy2j.js.map